import React from 'react';

/**
 * SettingsHeading represents the heading that appears at the top of the
 * tab pages in the settings menu.
 *
 *  Example
 *
 *  <SettingsHeading>Edit Roles</SettingsHeading>
 */
const SettingsHeading = ({ children }) => (
  <div>
    <h3 className="SettingsContent-heading">{children}</h3>
    <hr />
  </div>
);

export default SettingsHeading;
